import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { BASE_URL } from '../../config';
import { setCurrentPage } from '../../Redux/ActionCreater';
import 'react-toastify/dist/ReactToastify.css';
import { Helmet } from 'react-helmet-async';
// import { Helmet } from 'react-helmet';
import $ from "jquery";
function ContactUs() {
    const [data,setData]=useState();
const [page,setPage]=useState();
  const dispatch = useDispatch();
  const [formData,setFormData]=useState({
    name:"",
    email:"",
    phoneNumber:"",
    comment:"",
})
const [error,setError]=useState(false);
const [errorMsg,setErrorMsg]=useState("");
const [success,setSuccess]=useState(false);
const [successMsg,setSuccessMsg]=useState("");
const [value, setValue] = useState()
const state = useSelector(
    (state) => (
       state.dataReducer
    ),
    shallowEqual
  );

const onchange=(e)=>{
  if(success){
    setSuccess(false)
  }
    e.preventDefault();
    var reg = /^\d+$/;
    if(e.target.name==="phoneNumber"){
      if(reg.test(e.target.value)||e.target.value===""){
        setFormData({...formData,[e.target.name]:e.target.value});
      }
    }else{
      setFormData({...formData,[e.target.name]:e.target.value});
    }

}

const handleSubmit=async(e)=>{
  console.log(value)
    e.preventDefault();
    let regExp = /^[a-zA-Z0-9.-]+@[a-zA-Z0-9.-]+\.[A-Za-z]+$/;
    let numReg=/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
    // let numReg=/^(\+?\d{1,4}[\s-])?(?!0+\s+,?$)\d{10}\s*,?$/
    if (formData.name === ""||/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(formData.name)||/\d/.test(formData.name)){
        setErrorMsg("Please enter valid name with only alphabets and spaces!")
        return setError(true);
    }
    if (!regExp.test(formData.email)){
      setErrorMsg("Please enter valid email address!")
      return setError(true);
  }
  if (/[a-zA-Z]/.test(formData.phoneNumber)||!numReg.test(formData.phoneNumber)){
    setErrorMsg("Please enter your 10 digit phone number!")
    return setError(true);
}

  if (formData.comment === ""){
    setErrorMsg("Please enter comments!")
    return setError(true);
}
let data =new FormData();
data.append('name', formData.name);
data.append('email', formData.email);
data.append('message', formData.comment);
data.append('phone_no', formData.phoneNumber);

var config = {
  method: 'post',
  url: `${BASE_URL}/api/contactus`,
  headers: { 
    'X-Auth-Token': '12345', 
  },
  data : data
};

await axios(config)
.then(function (response) {
    let res=response.data
  console.log(JSON.stringify(response.data));
  if(res.code===200){
    setSuccessMsg(res.data)
    setError(false);
    setSuccess(true);
    setFormData({
        name:"",
        email:"",
        phoneNumber:"",
        comment:"",
    })
  }
})
.catch(function (error) {
  console.log(error.response.data.message[0]);
  setError(true);
  setErrorMsg(error.response.data.message[0])
});
// let response=await axios.post(`${BASE_URL}/api/contactus`,body);

}
 
  useEffect(() => {
    $('document').ready(function() {
      $(window).scrollTop(0);
   });
    dispatch(setCurrentPage("contact"));
    }, [])
  useEffect(() => {
    setData(state.settingData);
    setPage(state.currentPage)
    }, [state])
  return (
    <section className="contactcontainer">
      <Helmet>
          <title>{`CNC Machine :: Contact-us`}</title>
          {/* <meta name="description" content={res?.meta_description} />
          <meta name="keywords" content={res?.meta_keywords} />
          <meta name="title" content={res?.meta_title} /> */}
          <meta property="og:title" content="CNC Machine :: Contact-us"/>
          <meta name="description" content="Learn CNC machine maintence start your own business, get money back within a day. You can earn rs 10000 per day." />
        </Helmet>
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-xl-12 col-md-12 col-sm-12 col-12">
        <div className="ctformbox">
          <div className="row ml-0 mr-0">
            <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12 pl-0 pr-0 order-xl-1 order-lg-1">
              <div className="lboxcontent">
                <div className="lboxcontentinner">
                  <h1>GET IN TOUCH</h1>
                  <div className="coininfo">
                    <div className="cticon"><i className="icon icon-map-marker"></i></div>
                    <div className="cticontent">
                      <h4>Address</h4>
                      <p>{data?.site_address}</p></div>
                  </div>
                  <div className="coininfo">
                    <div className="cticon"><i className="icon icon-phone"></i></div>
                    <div className="cticontent">
                      <h4>Phone</h4>
                      <p><a href={`tel:${data?.site_phone_number}`}>{data?.site_phone_number}</a></p>
                    </div>
                  </div>
                  <div className="coininfo">
                    <div className="cticon"><i className="icon icon-envelope"></i></div>
                    <div className="cticontent">
                      <h4>Email</h4>
                      {/* <p><a href={`mailto:${data?.site_email}`}>{data?.site_email}</a></p> */}
                      <p style={{fontSize:"15px"}}><a href={`mailto:${data?.footer_email?.split("/")[0]}`}>{data?.footer_email?.split("/")[0]}</a></p>
                  <p style={{marginTop:"2px"}}><a href={`mailto:${data?.footer_email?.split("/")[1]}`}>{data?.footer_email?.split("/")[1]}</a></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-12 pl-0 pr-0">
              <div className="lblright">
                <div className="lblrightinner">
                  <div className="innerbox signupbox">
                    <div className="lgheading">SEND US A <span>MESSAGE</span></div>
                    <div className="lform">
                      {success&&<div className="alert alert-success alert-dismissible" id="suc" >
                        <a href="" className="close" data-dismiss="alert" aria-label="close" onClick={(e)=>{e.preventDefault();setSuccess(false)}}><i className="fa fa-times"></i></a>
                        {successMsg}
                      </div>}
                     {error&& <div className="alert alert-danger alert-dismissible" id="er" >
                        <a href="" className="close" data-dismiss="alert" aria-label="close" onClick={(e)=>{e.preventDefault();setError(false)}}><i className="fa fa-times"></i></a>
                        {errorMsg}   
                      </div>}
                      <form  action="" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-xl-6 col-md-6 col-sm-12 col-12">
                            <div className="form-group">
                              <input type="text" className="form-control" value={formData.name} name="name" onChange={onchange} placeholder="Name*"/>
                            </div>
                          </div>
                          <div className="col-xl-6 col-md-6 col-sm-12 col-12">
                            <div className="form-group">
                              <input type="text" className="form-control" value={formData.email} name="email" onChange={onchange} placeholder="Email*"/>
                            </div>
                          </div>
                          <div className="col-xl-12 col-md-12 col-sm-12 col-12">
                            <div className="form-group">
                            {/* <PhoneInput className="form-control"
                            defaultCountry="IN"
      placeholder="Enter phone number"
      value={value}
      onChange={setValue}
      /> */}
                              <input type="tel" className="form-control" value={formData.phoneNumber} name="phoneNumber" onChange={onchange} placeholder="Phone*"/>
                            </div>
                          </div>
                          <div className="col-xl-12 col-md-12 col-sm-12 col-12">
                            <div className="form-group">
                              <textarea className="form-control" name="comment" value={formData.comment} onChange={onchange}  placeholder="Comments*"></textarea>
                            </div>
                          </div>
                          <div className="col-xl-12 col-md-12 col-sm-12 col-12">
                            <button type="submit" className="contact-us-form">Send Your Message</button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
  )
}

export default ContactUs